import React, { useState, useCallback } from 'react';
import clsx from 'clsx';
import { HomeTableProps } from '../utils';
import HomeSectionTransactionTable from './HomeSectionTransactionTable';
import CSVDownloadButton from './common/CSVDownloadButton';
import CreditLineFilter from './common/CreditLineFilter';
import { transactionCSVColumns } from '../utils/csvColumns';
import styles from '../styles/components/TransactionTabsWithCSV.module.scss';

interface Tab {
  id: string;
  name: string;
  filter: string;
}

const tabs: Tab[] = [
  {
    id: 'credit-transaction',
    name: 'Credit transactions',
    filter: 'credit-transactions'
  },
  {
    id: 'repayments',
    name: 'Repayments',
    filter: 'repayments'
  }
];

function TransactionTabsWithCSV() {
  const [activeTab, setActiveTab] = useState(tabs[0].id);
  const [selectedCreditLineId, setSelectedCreditLineId] = useState<number | undefined>(undefined);
  const [transactionData, setTransactionData] = useState<HomeTableProps[]>([]);

  const activeTabData = tabs.find(tab => tab.id === activeTab);

  const handleDataChange = useCallback((data: HomeTableProps[]) => {
    setTransactionData(data);
  }, []);

  const getCSVFilename = (tabId: string) => {
    switch (tabId) {
      case 'credit-transaction':
        return 'credit-transactions';
      case 'repayments':
        return 'repayments';
      default:
        return 'transactions';
    }
  };

  return (
    <div className={styles.transactionTabs}>
      {/* Tab Header with CSV Button */}
      <div className={styles.tabHeader}>
        <div className={styles.tabNavList}>
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={clsx(
                styles.tabButton,
                activeTab === tab.id && styles.active
              )}
            >
              {tab.name}
            </button>
          ))}
        </div>
        
        <CSVDownloadButton
          data={transactionData}
          columns={transactionCSVColumns}
          filename={getCSVFilename(activeTab)}
          className={styles.csvButton}
        />
      </div>

      {/* Filter Controls */}
      <div className={styles.filterControls}>
        <CreditLineFilter
          selectedCreditLineId={selectedCreditLineId}
          onCreditLineChange={setSelectedCreditLineId}
          className={styles.creditLineFilter}
        />
      </div>

      {/* Tab Content */}
      <div className={styles.tabContent}>
        {activeTabData && (
          <HomeSectionTransactionTable 
            filter={activeTabData.filter}
            creditLineId={selectedCreditLineId}
            onDataChange={handleDataChange}
          />
        )}
      </div>
    </div>
  );
}

export default TransactionTabsWithCSV;
